/**
 * @module utils/model
 */

/**
 * @typedef {module:utils/object~Object} Object
 * @typedef {{}} Extension
 * @typedef {Object|Extension} Model
 */
import object from './object.js'

/**
 * Merges any number of object to a new frozen one, flagged by a Symbol
 * @param {Symbol} symbol
 * @param {...Extension} extensions
 * @returns {Model}
 */
export default (symbol, ...extensions) => {
  const model = Object.create(null, {
    constructor: {
      value: {
        [symbol]: () => {}
      }[symbol]
    }
  })

  model.constructor.prototype = model
  Object.freeze(model.constructor)

  return object(model, ...extensions)
}
